import React from "react";
import { Link } from "react-router-dom";
import MainFooter from "../shared/MainFooter.jsx";
import SiteLogo from "@/components/SiteLogo";
import { getSiteBrand } from "@/lib/siteHosts";

const LegalPageShell = ({ title, children }) => (
  <div className="choice-landing min-h-screen bg-[#080b14] noise-overlay">
    <header className="border-b border-white/[0.05]">
      <div className="max-w-3xl mx-auto px-6 py-6 flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <SiteLogo className="w-full max-w-[100px]" />
        </Link>
        <Link to="/" className="text-sm text-gray-400 hover:text-white transition-colors">
          ← Back to home
        </Link>
      </div>
    </header>

    <main className="max-w-3xl mx-auto px-6 py-16">
      <h1 className="text-3xl md:text-4xl font-semibold text-white mb-8">{title}</h1>
      <div className="prose prose-invert prose-sm max-w-none text-gray-400 space-y-6">{children}</div>
    </main>

    <MainFooter />
  </div>
);

const ContactPage = () => (
  <LegalPageShell title="Contact Us">
    <p>
      Have questions about {getSiteBrand().name} AI digital employees, deployment, or partnerships? We&apos;re here to help.
    </p>
    <div className="space-y-2 not-prose">
      <p>
        <span className="text-gray-500">Support:</span>{" "}
        <a href={`mailto:${getSiteBrand().supportEmail}`} className="text-teal-400 hover:text-teal-300">
          {getSiteBrand().supportEmail}
        </a>
      </p>
      <p>
        <span className="text-gray-500">General inquiries:</span>{" "}
        <a href={`mailto:${getSiteBrand().infoEmail}`} className="text-teal-400 hover:text-teal-300">
          {getSiteBrand().infoEmail}
        </a>
      </p>
    </div>
    <p>We typically respond within one business day.</p>
  </LegalPageShell>
);

export default ContactPage;
